'use client';

const STORAGE_KEY = 'search-history';

export const saveHistory = (history: string[]) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  }
};

export const loadHistory = (): string[] => {
  if (typeof window !== 'undefined') {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  }
  return [];
};
